export var TooltipTestIds = /*#__PURE__*/function (TooltipTestIds) {
  TooltipTestIds["ROOT"] = "tooltip-root";
  TooltipTestIds["TITLE"] = "tooltip-title";
  TooltipTestIds["TEXT"] = "tooltip-text";
  TooltipTestIds["AVATAR"] = "tooltip-avatar";
  TooltipTestIds["FALLBACK_AVATAR"] = "tooltip-fallback-avatar";
  TooltipTestIds["AVATAR_BADGE_IS_LIVE"] = "tooltip-avatar-badge-is-live";
  TooltipTestIds["AVATAR_BADGE_WAS_LIVE"] = "tooltip-avatar-badge-was-live";
  TooltipTestIds["USER_NAME"] = "tooltip-user-name";
  return TooltipTestIds;
}({});